import { render } from "./ModifMdp.vue?vue&type=template&id=1edca74e"
import script from "./ModifMdp.vue?vue&type=script&lang=js"
export * from "./ModifMdp.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phl/phlsupport/deploy-support-cli/front_vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__